import React from 'react'
import PropTypes from 'prop-types'
import { AVAILABLE_BRANDS } from 'styles/theme'
import * as S from './styled'
import Background from 'components/atoms/Background'

/* eslint multiline-ternary: "off" */
const Layout1 = ({ content: contents, setContentTime }) => {
  // Hardcodeado para MVP
  // const { color } = useTheme()
  const color = AVAILABLE_BRANDS.CLOUD_LIGHT

  if (color === AVAILABLE_BRANDS.CLOUD_DARK || color === AVAILABLE_BRANDS.CLOUD_LIGHT) {
    return (
      <S.Container>
        <Background illustration={contents?.ilustration} setContentTime={setContentTime} />
      </S.Container>
    )
  }
}

Layout1.defaultProps = {
  content: {},
  setContentTime: () => {},
}

Layout1.propTypes = {
  content: PropTypes.object,
  setContentTime: PropTypes.func,
}

export default Layout1
